// extracted by mini-css-extract-plugin
export default {"main":"Interlineales_main__Puqrg"};